import React from "react";

const ErrorComponent = () => {
  return (
    <div className="p-5 text-red-500 bg-red-100 rounded">
      Look like component is error
    </div>
  );
};

export default ErrorComponent;
